export default __webpack_public_path__ + "static/media/Futteruntersuchung.73b5ec6a.jpg";